import { AddToast } from "./Toast";
import { Btn } from "../ui/Btn";
import { F, T } from "../../theme/tokens";

// ── Confirm action modal ──────────────────────────────────────────────────────

export interface ConfirmState {
  open: boolean;
  title: string;
  body: string;
  destructive: boolean;
  confirmLabel: string;
  onConfirm: () => void;
}

export function ConfirmModal({ state, onClose, addToast }: { state: ConfirmState; onClose: () => void; addToast: AddToast }) {
  if (!state.open) return null;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: "14px", padding: "28px", width: "420px", maxWidth: "90vw", maxHeight: "90dvh", overflowY: "auto", fontFamily: F }}>
        <h3 style={{ fontSize: "15px", fontWeight: 600, color: T.text, marginBottom: "8px" }}>{state.title}</h3>
        <p style={{ fontSize: "13px", color: T.sub, lineHeight: 1.6, marginBottom: "24px" }}>{state.body}</p>
        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
          <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
          <Btn variant={state.destructive ? "destructive" : "primary"} onClick={() => { state.onConfirm(); onClose(); }}>{state.confirmLabel}</Btn>
        </div>
      </div>
    </div>
  );
}
